import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.h1 = this.el.querySelector('.c-heading')
    this.excerpt = this.el.querySelector('.intro-news__hero__excerpt')
    this.tags = this.el.querySelectorAll('.tag-capsule')
    this.shareWrapper = this.el.querySelector('.intro-news__bottom__share')
    this.shareBtn = this.el.querySelector('.intro-news__bottom__cell.sharer__btn')
    this.sharer = this.el.querySelector('.sharer')
    this.sharerBtns = this.sharer.querySelectorAll('.sharer__btn')
    this.closeBtn = this.el.querySelector('.intro-news__bottom__close')

    this.events = { click: {
      scroll: 'scrollToNext',
      expandSharer: 'expandSharer',
      closeSharer: 'closeSharer'
    } }
  }

  switchSingleNewsIntro(e) {
    if (e.way === 'enter') {
      this.h1.classList.add('is-inview')
      this.excerpt.classList.add('is-inview')

      gsap.to(this.tags, {
        duration: 0.6,
        ease: 'power2.out',
        opacity: 1,
        y: 0,
        stagger: { amount: 0.2 },
        delay: 0.25
      })
    }
  }

  scrollToNext() {
    this.call(
      'scrollTo',
      '.intro-news__bottom',
      'Scroll'
    )
  }

  expandSharer() {
    const tl = gsap.timeline()

    this.sharer.inert = false
    this.shareBtn.inert = true

    tl
      .add('start')
      .to(this.shareBtn, {
        duration: 0.2,
        ease: 'power2.out',
        autoAlpha: 0,
        pointerEvents: 'none'
      })
      .to(
        this.shareWrapper,
        {
          duration: 0.3,
          ease: 'power2.out',
          width: this.sharer.offsetWidth
        },
        'start+=0.1'
      )
      .set(
        this.sharer,
        {
          visibility: 'visible',
          pointerEvents: 'auto',
          userSelect: 'auto'
        },
        'start+=0.1'
      )
      .fromTo(
        this.sharerBtns,
        {
          opacity: 0,
          y: 20
        },
        {
          duration: 0.4,
          ease: 'power2.out',
          opacity: 1,
          y: 0,
          stagger: { amount: 0.2 }
        },
        'start+=0.15'
      )
      .fromTo(
        this.closeBtn,
        {
          display: 'none',
          opacity: 0
        },
        {
          duration: 0.3,
          ease: 'power2.out',
          display: 'flex',
          opacity: 1
        },
        'start+=0.2'
      )
  }

  closeSharer() {
    const tl = gsap.timeline()

    this.sharer.inert = true
    this.shareBtn.inert = false

    tl
      .add('start')
      .to(this.closeBtn, {
        duration: 0.2,
        ease: 'power2.out',
        display: 'none',
        opacity: 0
      })
      .to(
        this.sharer,
        {
          duration: 0.2,
          ease: 'power2.out',
          autoAlpha: 0,
          pointerEvents: 'none',
          userSelect: 'none',
          clearProps: 'opacity'
        },
        'start'
      )
      .to(
        this.shareWrapper,
        {
          duration: 0.3,
          ease: 'power2.out',
          width: this.shareBtn.offsetWidth,
          clearProps: 'width'
        },
        'start+=0.15'
      )
      .to(
        this.shareBtn,
        {
          duration: 0.2,
          ease: 'power2.out',
          autoAlpha: 1,
          pointerEvents: 'auto'
        },
        'start+=0.3'
      )
  }
}
